module.exports = __webpack_public_path__ + "static/media/icons.962a1bf3.svg";